import { ReactNode, forwardRef } from 'react';

import {
  Chip,
  TableCell,
  TableCellProps,
  Tooltip,
  makeStyles,
} from '@material-ui/core';

import { Link } from '@backstage/core-components';

import { MetadataText } from '@spotify/confidence-core-react';
import { CommentFragment } from '@spotify/confidence-graphql';
import { useAssignCount } from '@spotify/plugin-confidence-workflows-react';

type Comments = {
  comments: Array<Pick<CommentFragment, 'assignee' | 'resolved'>>;
};

interface NameCellProps extends TableCellProps {
  href: string;
  comments?: Comments | null;
  kind: string;
  secondaryText?: ReactNode;
  displayName: string;
}

const useStyles = makeStyles({
  assignCountBadge: {
    verticalAlign: 'baseline',
    marginLeft: 4,
  },
});

export const NameCell = forwardRef<HTMLTableCellElement, NameCellProps>(
  ({ href, displayName, kind, comments, secondaryText, ...props }, ref) => {
    const classes = useStyles();

    const assignCount = useAssignCount(comments?.comments ?? []);

    return (
      <TableCell {...props} ref={ref}>
        <Link to={href}>{displayName}</Link>
        {assignCount > 0 && (
          <Tooltip title={`${assignCount} assigned threads`}>
            <Chip
              size="small"
              label={assignCount.toString()}
              className={classes.assignCountBadge}
            />
          </Tooltip>
        )}
        <MetadataText items={[kind, secondaryText]} />
      </TableCell>
    );
  },
);
NameCell.displayName = 'NameCell';
